import React, {useState, useRef, useEffect} from 'react';
import {getIntersectionObserverInstance} from '@ibibo/intersection-observer';

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1,
};

let observer = '';
let IntersectionObserver = getIntersectionObserverInstance();

// we should move it to util which will return the observer instance in .client.js and an dummy thing in .server.js
if (IntersectionObserver) {
  observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      // if element is intersecting as per threshold set, then update state and remove observer
      if (entry.isIntersecting) {
        entry.target.src = entry.target.dataset.src;
        observer.disconnect(entry.target);
      }
    });
  }, options);
}

const Image = (props: {src: string; alt?: string; fallback?: string; className?: string}) => {
  const {src, alt = '', fallback = '', className} = props;
  const sourceRef = useRef();
  const [error, setOnError] = useState(false);

  useEffect(() => {
    if (observer) observer.observe(sourceRef.current);
  }, []);

  // if (true) return <img ref={sourceRef} {...props} src={src} alt={alt} />;

  if (error) return <img ref={sourceRef} {...props} src={fallback} alt={alt} />;

  return (
    <img
      ref={sourceRef}
      src={src}
      alt={alt}
      className={className}
      data-src={src}
      // alt={alt}
      onError={() => {
        setOnError(true);
      }}
    />
  );
};

export default Image;
